export const SUMMARY_DEFAULT = '/';
export const SUMMARY_SELF_INTRODUCTION='/self-introduction';
export const SUMMARY_PROJECTS = '/projects';
export const SUMMARY_OTHERS = '/others';
export const SUMMARY_ALL = '/all';
